import { useEffect } from 'react';
import { setAccessToken } from '@cordata/buffet';

const TokenExtractor = () => {
  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      setAccessToken(token);
      window.location = '/home';
    }
  }, []);

  return null;
};

export default TokenExtractor;
